import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {DesignServicesModel} from '../../../../models/DesignServicesModel';
import {Sl1AnagrafService} from '../../../general-services/service-sl1-services/sl1-anagraf.service';
import * as toastr from 'toastr';

@Component({
  selector: 'app-new-design-services-anagraf',
  templateUrl: './new-sl1-anagraf.component.html',
  styleUrls: ['./new-sl1-anagraf.component.scss']
})
export class NewSl1AnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  designServices: DesignServicesModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  saveSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private designServicesService: Sl1AnagrafService) {
    super();

    this.designServices = new DesignServicesModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [this.designServices.cod, [Validators.required]],
      description: [this.designServices.description, [Validators.required]]
    });
  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL1_ANAGRF]);
  }

  save(event: any, form: NgForm, clickSalva ?: boolean) {
    if (event.key === 'Enter' || clickSalva) {
      event.preventDefault();
      this.designServices.cod = this.formValidator.value.cod;
      this.designServices.description = this.formValidator.value.description;
      this.saveSubscribe = this.designServicesService.save(this.designServicesService.baseUrl, this.designServices).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, SL1 Cod already exists', 'Warning');
          } else {
            toastr.success('Element added with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL1_ANAGRF]);
          }
        }, error => {
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

}
